import type { JSX } from 'react';

import { CheckCircleOutlineIcon } from '@change/ds-icons';

import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { ToastBanner } from '../../../GrowPetition/components/ShareVisual/components/ToastBanner';

export function DownloadedMessage(): JSX.Element {
	return (
		<div className="pr-4 pt-6">
			<ToastBanner
				data-testid="social-media-content-downloaded"
				className="bg-fill-success-weaker border-stroke-success-weak rounded-lg border px-4 py-3"
			>
				<CheckCircleOutlineIcon className="text-icon-success" size={24} />
				<Text className="text-typography-success" fontWeight="bold">
					<div className="hidden md:flex">
						<Translate value="corgi.petition.starter_dashboard_v2.shared.share_visuals.downloaded_desktop" />
					</div>
					<div className="flex md:hidden">
						<Translate value="corgi.petition.starter_dashboard_v2.shared.share_visuals.downloaded_mobile" />
					</div>
				</Text>
			</ToastBanner>
		</div>
	);
}
